// Single source of truth for the `file://` URI scheme. Used by the
// asset cache, sanitization hook, camera/upload flows, and anywhere
// else native code shuttles paths between RN APIs (which often want
// bare paths) and renderers/`fetch` (which need the scheme).
export const FILE_URI_SCHEME = 'file://';

// `unknown` parameter avoids over-narrowing in the `else` branch when
// callers pass a value already typed as `string` (a `uri is string`
// predicate would narrow the negative branch to `never`).
export function isFileUri(uri: unknown): boolean {
  return typeof uri === 'string' && uri.startsWith(FILE_URI_SCHEME);
}

// Idempotent: returns the input unchanged when it already carries
// the scheme. Use this anywhere code did `` `file://${path}` `` so we
// don't double-prefix when callers pass an already-prefixed value.
export function toFileUri(path: string): string {
  return path.startsWith(FILE_URI_SCHEME) ? path : `${FILE_URI_SCHEME}${path}`;
}

// Returns the input unchanged when it's a file URI, `null` otherwise.
// Use when the caller wants the typed value back rather than a boolean.
export function asFileUri(uri: string | null | undefined): string | null {
  if (typeof uri === 'string' && uri.startsWith(FILE_URI_SCHEME)) return uri;
  return null;
}
